/**
 * Clemtex.CategoryLinks.Render - HTML strings + the stylesheet.
 *
 * The CSS ships inside the JS and is injected once as <style id="cx-styles">:
 * the Extension Manager's Sass step has failed activations on this account
 * (CustomPackages, Oct 2026), so this extension has no Sass at all.
 * Ported from the approved mock-ups (Cross-Link Mockups/mock-inject.js).
 * Keep this file pure ASCII.
 */
define('Clemtex.CategoryLinks.Render', ['Clemtex.CategoryLinks.Rules'], function (Rules) {
    'use strict';

    var esc = Rules.esc;
    var DOT = '<span class="cx-bar-q cx-dot" aria-hidden="true">&middot;</span>';

    var CSS = [
        '.cx-bar{display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 12px;margin:14px 0 6px;padding:9px 14px;background:#f4f5f7;border-left:3px solid #1f2733;font-size:15px;line-height:1.4;color:#1f2733;max-width:100%;box-sizing:border-box}',
        '.cx-bar-q{color:#5f6b7a}',
        '.cx-bar a{color:#1f2733;font-weight:500;text-decoration:underline;text-underline-offset:3px}',
        '.cx-bar a:hover{color:#000}',
        '.cx-bar .cx-c{font-weight:400}',
        '.cx-bar-more{margin-left:auto;font-size:13px;color:#5f6b7a!important;font-weight:400!important;background:none;border:0;padding:0;cursor:pointer;text-decoration:underline;text-underline-offset:3px;font-family:inherit}',
        '.cx-bar .cx-m{display:none}',
        '.cx-bar--pdp{margin:16px 0 4px}',
        '@media (max-width:767px){.cx-bar{font-size:14px;margin:10px 0 4px}.cx-bar-more{margin-left:0}.cx-bar .cx-bar-x{display:none}.cx-bar .cx-m{display:inline}.cx-bar .cx-d{display:none}}',
        '.cx-strip{clear:both;margin:36px 0 24px;border-top:1px solid #e1e4e8;border-bottom:1px solid #e1e4e8;padding:6px 0;color:#1f2733;max-width:100%}',
        '.cx-strip[hidden]{display:none}',
        '.cx-strip-title{font-family:Oswald,"Arial Narrow",sans-serif;font-size:22px;text-transform:uppercase;letter-spacing:.03em;font-weight:400;margin:10px 0 4px;color:#1f2733}',
        '.cx-strip--drawer{margin:0 0 18px;border-top:0;background:#fafbfc;padding:4px 14px 6px;border-left:3px solid #1f2733}',
        '.cx-group{display:grid;grid-template-columns:232px minmax(0,1fr);gap:18px;align-items:center;padding:14px 0}',
        '.cx-strip--drawer .cx-group{grid-template-columns:200px minmax(0,1fr)}',
        '.cx-group+.cx-group{border-top:1px dashed #e1e4e8}',
        '.cx-label{font-family:Oswald,"Arial Narrow",sans-serif;font-size:17px;line-height:1.2;text-transform:uppercase;letter-spacing:.03em;margin:0;color:#1f2733;font-weight:400}',
        '.cx-sub{display:block;font-family:Roboto,Lato,"Helvetica Neue",Arial,sans-serif;font-size:13px;text-transform:none;letter-spacing:0;color:#5f6b7a;margin-top:4px}',
        '.cx-row{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;padding:2px 2px 6px;-webkit-overflow-scrolling:touch}',
        '.cx-tile{flex:0 0 258px;scroll-snap-align:start;display:flex;align-items:center;gap:14px;border:1px solid #d5d9de;background:#fff;padding:10px 14px 10px 10px;text-decoration:none!important;color:#1f2733!important;box-sizing:border-box}',
        '.cx-tile:hover{border-color:#1f2733;box-shadow:0 2px 8px rgba(31,39,51,.12)}',
        '.cx-tile img{width:64px;height:64px;object-fit:contain;flex:0 0 64px;background:#fff}',
        '.cx-tile .cx-noimg{width:64px;height:64px;flex:0 0 64px;background:#f4f5f7}',
        '.cx-text{flex:1 1 auto;min-width:0}',
        '.cx-name{display:block;font-family:Oswald,"Arial Narrow",sans-serif;font-size:16px;line-height:1.2;text-transform:uppercase;letter-spacing:.02em}',
        '.cx-count{display:block;font-size:13px;color:#5f6b7a;margin-top:3px;min-height:16px}',
        '.cx-arrow{flex:0 0 auto;font-size:20px;line-height:1}',
        '@media (max-width:767px){.cx-strip{margin:18px 0 8px}.cx-group,.cx-strip--drawer .cx-group{grid-template-columns:minmax(0,1fr);gap:10px;padding:12px 0}.cx-tile{flex-basis:232px}.cx-strip--drawer{padding:2px 10px 4px}}',
        '.cx-pdp{margin:36px auto 28px;max-width:1080px;padding:0 15px;box-sizing:border-box}',
        '.cx-pdp .cx-sub{margin:10px 0 0}',
        '.cx-pdp-body{display:grid;grid-template-columns:280px minmax(0,1fr);gap:12px;align-items:stretch;margin-top:14px}',
        '.cx-pdp-body .cx-tile{height:100%}',
        '.cx-parts{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}',
        '.cx-part{display:block;border:1px solid #e1e4e8;padding:8px;text-decoration:none!important;color:#1f2733!important;text-align:center;background:#fff}',
        '.cx-part:hover{border-color:#1f2733}',
        '.cx-part img{width:100%;height:76px;object-fit:contain}',
        '.cx-part-id{display:block;font-size:12px;color:#5f6b7a;margin-top:6px}',
        '.cx-part-name{display:block;font-size:13px;line-height:1.3;margin-top:2px;height:51px;overflow:hidden}',
        '.cx-part-price{display:block;font-size:14px;font-weight:500;margin-top:4px}',
        '@media (max-width:767px){.cx-pdp-body{grid-template-columns:minmax(0,1fr)}.cx-parts{grid-template-columns:repeat(2,minmax(0,1fr))}}'
    ].join('\n');

    function injectStyles() {
        if (document.getElementById('cx-styles')) { return; }
        var st = document.createElement('style');
        st.id = 'cx-styles';
        st.appendChild(document.createTextNode(CSS));
        (document.head || document.documentElement).appendChild(st);
    }

    function countSlot(e, format) {
        return '<span class="' + (format === 'bar' ? 'cx-c' : 'cx-count') + '" data-cx-count="' + esc(e.to) + '" data-cx-url="' + esc(e.url) + '" data-cx-format="' + format + '"></span>';
    }

    /**
     * The one-line bar. mode: 'bar' (no more link) | 'bar+bottom' (scroll to the strip)
     * | 'bar+inline' (toggle the drawer). Desktop shows 3 links, phone 2 (CSS).
     */
    function bar(question, entries, mode, opts) {
        opts = opts || {};
        var desk = Rules.barFor(entries, 3);
        var phone = Rules.barFor(entries, 2);
        if (!desk) { return ''; }
        var html = '<div class="cx-bar' + (opts.extraClass ? ' ' + opts.extraClass : '') + '" data-cx-root="' + esc(opts.root || 'bar') + '">' +
            '<span class="cx-bar-q">' + esc(question) + '</span>';
        desk.links.forEach(function (e, i) {
            var x = i >= 2 ? ' cx-bar-x' : '';
            if (i) { html += DOT.replace('cx-dot', 'cx-dot' + x); }
            html += '<a class="' + x.trim() + '" href="' + esc(e.url) + '">' + esc(e.name) + ' ' + countSlot(e, 'bar') + '</a>';
        });
        if (opts.moreHtml) {
            html += opts.moreHtml;
        } else if (mode === 'bar+bottom' || mode === 'bar+inline') {
            var d = desk.more > 0 ? '+' + desk.more + ' more related' : 'All related';
            var m = phone.more > 0 ? '+' + phone.more + ' more related' : 'All related';
            var label = '<span class="cx-d">' + d + '</span><span class="cx-m">' + m + '</span>';
            html += mode === 'bar+inline'
                ? '<button type="button" class="cx-bar-more" data-cx-toggle aria-expanded="false" aria-controls="cx-drawer">' + label + ' &#9662;</button>'
                : '<button type="button" class="cx-bar-more" data-cx-jump="cx-related">' + label + ' &darr;</button>';
        }
        return html + '</div>';
    }

    function tile(e) {
        return '<a class="cx-tile" href="' + esc(e.url) + '">' +
            (e.img ? '<img src="' + esc(e.img) + '" alt="" loading="lazy">' : '<span class="cx-noimg" aria-hidden="true"></span>') +
            '<span class="cx-text"><span class="cx-name">' + esc(e.name) + '</span>' + countSlot(e, 'tile') + '</span>' +
            '<span class="cx-arrow" aria-hidden="true">&rsaquo;</span></a>';
    }

    /** Tile groups. kind: 'bottom' (after the grid) | 'drawer' (under the bar, starts hidden). */
    function strip(groups, kind) {
        var drawer = kind === 'drawer';
        var html = '<section class="cx-strip cx-strip--' + kind + '" id="' + (drawer ? 'cx-drawer' : 'cx-related') + '" data-cx-root="' + kind + '" aria-label="Related categories"' + (drawer ? ' hidden' : '') + '>';
        if (!drawer) { html += '<h2 class="cx-strip-title">Related categories</h2>'; }
        groups.forEach(function (g) {
            html += '<div class="cx-group"><h3 class="cx-label">' + esc(g.label) +
                (g.sub ? '<span class="cx-sub">' + esc(g.sub) + '</span>' : '') + '</h3>' +
                '<div class="cx-row">' + g.entries.map(tile).join('') + '</div></div>';
        });
        return html + '</section>';
    }

    /** Product page: the one-line link under Add to Cart. */
    function pdpLine(link, hasPanel) {
        var e = { to: link.to, url: link.url, name: link.name, rel: 'parts' };
        // Buttons, never href="#...": the SC router takes over every link click and
        // navigated to /cx-related (2026-10-26).
        var more = hasPanel ? '<button type="button" class="cx-bar-more" data-cx-jump="cx-pdp">Popular parts below &darr;</button>' : '';
        return bar('Parts for this tool:', [e], 'bar', { root: 'pdp-line', extraClass: 'cx-bar--pdp', moreHtml: more });
    }

    function partCard(c) {
        return '<a class="cx-part" href="' + esc(c.url) + '">' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '') +
            '<span class="cx-part-id">' + esc(c.sku) + '</span>' +
            '<span class="cx-part-name">' + esc(c.name) + '</span>' +
            (c.price ? '<span class="cx-part-price">' + esc(c.price) + '</span>' : '') + '</a>';
    }

    /**
     * Product page: the panel in the related-items area. Wrapped in the theme's own
     * .item-relations-correlated so the heading matches "Customers who bought...".
     */
    function pdpPanel(link, cards) {
        var e = { to: link.to, url: link.url, name: link.name, img: link.img };
        return '<aside class="item-relations-correlated cx-pdp" id="cx-pdp" data-cx-root="pdp-panel">' +
            '<h3>Parts for this tool</h3>' +
            '<span class="cx-sub">Replacement parts and consumables that fit this tool</span>' +
            '<div class="cx-pdp-body">' + tile(e) +
            '<div class="cx-parts" data-cx-cards>' + (cards || []).map(partCard).join('') + '</div></div></aside>';
    }

    function formatCount(n, format) {
        if (n === null || n === undefined) { return ''; }
        return format === 'bar' ? '(' + n + ')' : n + (n === 1 ? ' product' : ' products');
    }

    return {
        CSS: CSS,
        injectStyles: injectStyles,
        bar: bar,
        strip: strip,
        tile: tile,
        pdpLine: pdpLine,
        pdpPanel: pdpPanel,
        partCard: partCard,
        formatCount: formatCount
    };
});
